<template>
  <v-hover v-model="hover" close-delay="2000">
    <div ref="teamcaptainVideo" :style="{ width, height }">
      <v-expand-transition>
        <v-overlay absolute class="teamcaptain-overlay" opacity="0.75" v-if="teamCaptainData && hover">
          <v-list-item>
            <v-list-item-content class="py-0">
              <v-list-item-title>
                {{ teamCaptainData.username }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="$store.state.activityTeam">
                {{ $store.state.activityTeam.name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else>
                {{ $store.state.event.name }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-overlay>
      </v-expand-transition>
    </div>
  </v-hover>
</template>

<script>
import OT from "@opentok/client";

export default {
  data() {
    return {
      publisher: null,
      teamCaptainData: null,
      hover: false,
      initHoverTimeout: null,
    };
  },
  computed: {
    ratio() {
      if (!this.publisher) return 1;
      return (this.publisher.videoWidth() * 9) / (this.publisher.videoHeight() * 16);
    },
    width() {
      if (!this.publisher) return "40%";
      if (this.ratio > 1) return "70%";
      return Math.round(800 * this.ratio) / 10 + "%";
    },
    height() {
      if (!this.publisher) return "40%";
      if (this.ratio > 1) return Math.round(700 / this.ratio) / 10 + "%";
      return "80%";
    },
  },
  methods: {
    publishTeamCaptainStream() {
      const session = this.$store.state.sessionObject;
      if (this.publisher) {
        session.unpublish(this.publisher);
        this.publisher = null;
        this.$emit("unpublish");
      } else {
        const publisher = OT.initPublisher(
          this.$refs.teamcaptainVideo,
          {
            insertMode: "append",
            width: "100%",
            height: "100%",
          },
          (error) => {
            if (error) {
              console.error(error);
              return;
            }
            this.$emit("publish");
            this.publisher = publisher;
            session.publish(publisher, (error) => {
              if (error) console.error(error);
              // teamCaptainData is only available after publishing
              this.teamCaptainData = JSON.parse(publisher.stream.connection.data);
            });
          }
        );
      }
    },
    subscribeTeamCaptainStream(stream) {
      const publisher = this.$store.state.sessionObject.subscribe(
        stream,
        this.$refs.teamcaptainVideo,
        {
          insertMode: "append",
          width: "100%",
          height: "100%",
        },
        (error) => {
          if (error) console.error(error);
          this.$emit("receiving");
          this.publisher = publisher;
          this.teamCaptainData = JSON.parse(publisher.stream.connection.data);
        }
      );
    },
  },
  async mounted() {
    const session = this.$store.state.sessionObject;
    if (session.streams && session.streams.length) {
      session.streams.forEach((stream) => this.subscribeTeamCaptainStream(stream));
    }
    session.on("streamCreated", (event) => this.subscribeTeamCaptainStream(event.stream));
    session.on("streamDestroyed", () => {
      this.publisher = null;
      this.$emit("stop");
    });
  },
  watch: {
    publisher(val) {
      if (val) {
        this.hover = true;
        this.initHoverTimeout = setTimeout(() => (this.hover = false), 8000);
      } else {
        this.teamCaptainData = null;
      }
    },
    hover(val) {
      if (!val && this.initHoverTimeout) clearTimeout(this.initHoverTimeout);
    },
  },
};
</script>

<style scoped>
.teamcaptain-overlay {
  top: auto;
  height: 48px;
}
</style>
